@import "@/styles/variables";

.field {
	display: flex;
	flex-direction: column;
	gap: 0.35rem;
	min-width: 0;
}

.col12 {
	grid-column: span 12;
}

.col6 {
	grid-column: span 6;
}

.col3 {
	grid-column: span 3;
}

.label {
	font-weight: 600;
	font-size: 0.875rem;
	color: $gray-600;
	margin-bottom: 0;
}

.req {
	color: $danger-color;
	margin-left: 2px;
}

.inputWrapper {
	position: relative;
	width: 100%;
}

.input {
	width: 100%;
	border: 1px solid $gray-200;
	border-radius: 0.5rem;
	padding: 0.5rem 0.65rem;
	font-size: 0.95rem;
	color: $gray-700;
	background: #fff;
	outline: none;
	transition:
		border-color 0.15s ease,
		box-shadow 0.15s ease;
}

.input:focus {
	border-color: $primary-light;
	box-shadow: 0 0 0 3px rgba($primary-color, 0.15);
}

.input:disabled {
	background-color: $gray-100;
	color: $gray-400;
	cursor: not-allowed;
}

.input::placeholder {
	color: $gray-400;
}

.input[type="date"]::-webkit-calendar-picker-indicator {
	cursor: pointer;
}

.sm {
	padding: 0.4rem 0.6rem;
	font-size: 0.9rem;
}

.md {
	padding: 0.5rem 0.65rem;
	font-size: 0.95rem;
}

.lg {
	padding: 0.6rem 0.75rem;
	font-size: 1rem;
}

.inputError {
	border-color: $danger-color;
}

.inputError:focus {
	border-color: $danger-hover;
	box-shadow: 0 0 0 3px rgba($danger-color, 0.15);
}

.helper {
	font-size: 0.8rem;
	color: $gray-500;
}

.error {
	font-size: 0.8rem;
	color: $danger-hover;
	margin-top: -5px;
}

@media (max-width: 640px) {
	.col6 {
		grid-column: span 12;
	}
}
